module.exports = __webpack_public_path__ + "img/gi_tembak.d3ef7c96.png";